import { track } from "instrumentation/tracking/track";

export const trackClickAppStoreCategoryDropdown = (fields) => track("track_click_app_store_category_dropdown", fields);

export const trackClickIntegrationCardEdit = (fields) => track("track_click_integration_card_edit", fields);

export const trackClickIntegrationCardDisconnect = (fields) => track("track_click_integration_card_disconnect", fields);
